import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-list" }
const _hoisted_2 = { class: "operation-container" }
const _hoisted_3 = { class: "tbl-user-list" }

import {
  createOrganizationApi,
  fetchOrganizationListApi,
} from "@/api/organization/organizationApi";
import router from "@/router";
import {
  FetchOrganizationListParams,
  Organization,
} from "@/types/organization";
import { ElMessage, FormInstance, FormRules } from "element-plus";
import { onMounted, reactive, ref } from "vue";

// 获取用户列表

export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationListView',
  setup(__props) {

const tblOrganizationListLoading = ref<boolean>(false);
const orgList = ref<Organization[]>([]);
const params = reactive<FetchOrganizationListParams>({
  page: 1,
  size: 20,
  name: "",
});
const fetchOrganizationList = async () => {
  tblOrganizationListLoading.value = true;
  const response = await fetchOrganizationListApi(params);
  tblOrganizationListLoading.value = false;
  if (response) {
    orgList.value = response;
  }
};

// 用户列表点击进入用户信息
const enterOrganizationInfo = (org: Organization) => {
  console.log(org);
  router.push({ name: "organizationInfo", query: { orgId: org.id } });
};

// 创建用户
const createdUserFormRef = ref<FormInstance>();
const createdOrganizationDrawerVisible = ref<boolean>(false);
const createdUserRule = reactive<FormRules>({
  name: [{ required: true, message: "请输入集团名称", trigger: "blur" }],
});
const createdOrganizationForm = reactive({
  name: "",
});
const createOrganization = () => {
  createdOrganizationDrawerVisible.value = true;
};
const btnSubmitLoading = ref<boolean>(false);
const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate(async (valid) => {
    if (valid) {
      const organization = {
        name: createdOrganizationForm.name,
      } as Organization;
      btnSubmitLoading.value = true;
      const response = await createOrganizationApi(organization);
      console.log(response);
      btnSubmitLoading.value = false;
      if (response && response == true) {
        ElMessage.success("集团创建成功！");
        createdOrganizationDrawerVisible.value = false;
        fetchOrganizationList();
      } else {
        ElMessage.error("集团创建失败！");
      }
    } else {
      ElMessage.error("信息填写错误！");
    }
  });
};

const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
  createdOrganizationDrawerVisible.value = false;
};

onMounted(() => {
  fetchOrganizationList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t("r.organization_list")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (createOrganization()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("organization.create")), 1)
        ]),
        _: 1
      })
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "query-container" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        height: "90%",
        data: orgList.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            width: "400",
            prop: "id",
            label: _ctx.$t('ULV.id')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "name",
            "show-overflow-tooltip": "",
            label: _ctx.$t('ULV.name')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            width: "200",
            label: _ctx.$t('ULV.operation')
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (enterOrganizationInfo(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("ULV.btnEnterUserInfo")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tblOrganizationListLoading.value]
      ])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: createdOrganizationDrawerVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((createdOrganizationDrawerVisible).value = $event)),
      title: _ctx.$t('organization.create')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "createdUserFormRef",
          ref: createdUserFormRef,
          model: createdOrganizationForm,
          "label-width": "auto",
          rules: createdUserRule
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('organization.name'),
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: createdOrganizationForm.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((createdOrganizationForm.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  loading: btnSubmitLoading.value,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (submitForm(createdUserFormRef.value)))
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" 创建 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_el_button, {
                  type: "danger",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (resetForm(createdUserFormRef.value)))
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode(" 取消 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})